import { APIClient } from '../APIClient'
import type { ReviewSentence } from 'src/biz_spa/types'
import type {
  ReadSentenceRequestParams,
  ReadSentenceRequestParamsServer,
  SearchKeywordImpressionsAggregatesParams,
  SearchKeywordImpressionsAggregatesRequest,
  SearchKeywordImpressionsAggregatesResponse,
  SearchKeywordImpressionsPlotsParams,
  SearchKeywordImpressionsPlotsRequest,
  SearchKeywordImpressionsPlotsResponse
} from './types'

export class AnalysisAPIClient extends APIClient {
  constructor() {
    super()
  }

  async readSentences(companyUuid: string, params: ReadSentenceRequestParams): Promise<ReviewSentence[]> {
    const response = await this.post<ReadSentenceRequestParamsServer, { data: ReviewSentence[] }>(`/api/companies/${companyUuid}/reviews/sentences.json`, {
      ...params,
      startDate: params.startDate.format('YYYY-MM-DD'),
      endDate: params.endDate.format('YYYY-MM-DD'),
    })
    return response.data.data
  }

  async readSearchKeywordImpressionsAggregates(companyUuid: string, params: SearchKeywordImpressionsAggregatesParams) {
    const formattedParams: SearchKeywordImpressionsAggregatesRequest= {
      ...params,
      startTime: params.startTime.format('YYYY-MM-DD'),
      endTime: params.endTime.format('YYYY-MM-DD'),
    }
    const response = await this.post<SearchKeywordImpressionsAggregatesRequest, SearchKeywordImpressionsAggregatesResponse>(
      `/api/companies/${companyUuid}/analysis/search_keyword_impressions/aggregates`,
      formattedParams,
    )

    return response.data
  }

  async readSearchKeywordImpressionsAggregatesCount(companyUuid: string, params: SearchKeywordImpressionsAggregatesParams) {
    const formattedParams: SearchKeywordImpressionsAggregatesRequest= {
      ...params,
      startTime: params.startTime.format('YYYY-MM-DD'),
      endTime: params.endTime.format('YYYY-MM-DD'),
    }
    const response = await this.post<SearchKeywordImpressionsAggregatesRequest, { data: number }>(
      `/api/companies/${companyUuid}/analysis/search_keyword_impressions/count`,
      formattedParams,
    )

    return response.data.data
  }

  async readSearchKeywordImpressionsPlots(companyUuid: string, params: SearchKeywordImpressionsPlotsParams) {
    const formattedParams: SearchKeywordImpressionsPlotsRequest = {
      ...params,
      startTime: params.startTime.format('YYYY-MM-DD'),
      endTime: params.endTime.format('YYYY-MM-DD'),
    }
    const response = await this.post<SearchKeywordImpressionsPlotsRequest, SearchKeywordImpressionsPlotsResponse>(
      `/api/companies/${companyUuid}/analysis/search_keyword_impressions/graph_elements`,
      formattedParams,
    )

    return response.data
  }
}

export * from './types'
